import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthserviceService } from '../auth/authservice.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { ResolvedTheme, ThemeMode, ThemeService } from '../core/theme/theme.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {
   @Output() menuToggle = new EventEmitter<void>();

  retrievedData: any;
  retrievedData1: any;
  active: any;
  themeMode: ThemeMode = 'light';
  resolvedTheme: ResolvedTheme = 'light';
  isFullscreen = false;

  private readonly destroy$ = new Subject<void>();
  private readonly onFullscreenChange = () => this.syncFullscreenState();

    constructor(
    private authserivce: AuthserviceService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private themeService: ThemeService
  ) { }
  

  
  ngOnInit(): void {
    this.retrievedData = localStorage.getItem('userName');
    this.retrievedData1 = localStorage.getItem('campusName');
    this.themeMode = this.themeService.mode;
    this.resolvedTheme = this.themeService.resolved;
    this.themeService.mode$.pipe(takeUntil(this.destroy$)).subscribe((m) => (this.themeMode = m));
    this.themeService.resolved$.pipe(takeUntil(this.destroy$)).subscribe((r) => (this.resolvedTheme = r));
    this.syncFullscreenState();
    document.addEventListener('fullscreenchange', this.onFullscreenChange);
  }

  ngOnDestroy(): void {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Single click toggles fullscreen on/off */
  toggleFullscreen(): void {
    if (this.getFullscreenElement()) {
      this.exitFullscreen();
    } else {
      this.enterFullscreen();
    }
  }

  onMenuClick(): void {
    this.menuToggle.emit();
  }

  /** Single click: light icon ↔ dark icon / theme */
  toggleTheme(): void {
    this.themeService.toggle();
  }

  setTheme(mode: ThemeMode): void {
    this.themeService.setMode(mode);
  }

  Logout() {
    const logoutPage = localStorage.getItem('logoutPage')
    if (logoutPage) {
      window.location.href = logoutPage;
    }
  }

  private syncFullscreenState(): void {
    this.isFullscreen = !!this.getFullscreenElement();
  }

  private getFullscreenElement(): Element | null {
    const doc = document as Document & {
      webkitFullscreenElement?: Element | null;
      msFullscreenElement?: Element | null;
    };
    return doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement || null;
  }

  private enterFullscreen(): void {
    const el = document.documentElement as HTMLElement & {
      webkitRequestFullscreen?: () => Promise<void> | void;
      msRequestFullscreen?: () => Promise<void> | void;
    };
    const request =
      el.requestFullscreen?.bind(el) ||
      el.webkitRequestFullscreen?.bind(el) ||
      el.msRequestFullscreen?.bind(el);
    try {
      const result = request?.();
      if (result && typeof (result as Promise<void>).catch === 'function') {
        (result as Promise<void>).catch(() => undefined);
      }
    } catch {
      /* ignore unsupported / blocked fullscreen */
    }
  }

  private exitFullscreen(): void {
    const doc = document as Document & {
      webkitExitFullscreen?: () => Promise<void> | void;
      msExitFullscreen?: () => Promise<void> | void;
    };
    const exit =
      doc.exitFullscreen?.bind(doc) ||
      doc.webkitExitFullscreen?.bind(doc) ||
      doc.msExitFullscreen?.bind(doc);
    try {
      const result = exit?.();
      if (result && typeof (result as Promise<void>).catch === 'function') {
        (result as Promise<void>).catch(() => undefined);
      }
    } catch {
      /* ignore */
    }
  }


}



